export const engagementLandingPagesAppGroupIdLimits = "/engagement/landing_pages/:app_group_id/limits";
